<template>
  <div class="Index">
    <div class="theme"></div>
    <div class="title"></div>
    <div class="subtitle"></div>
    <div class="illustration"></div>
    <div class="goClassification" @click.stop.prevent="goClassification">
      立即体验
    </div>
    <div class="bottomMask"></div>
    <!-- <div class="deerAnimee"></div> -->
  </div>
</template>

<script>
// 引入wxjs
import wx from 'weixin-js-sdk'
import { getData, getTxt, saveData } from '../api/index'
export default {
  name: 'index',
  data () {
    return {}
  },
  created () {
    // this.getShareInfo();
  },

  mounted () {},
  beforeDestroy () {},

  methods: {
    async getTxt () {
      const res = await getTxt()
      console.log(res, 'getTxt')
    },

    async goClassification () {
      // const data = {
      //   key: "HEALTH_CARE_KEY",
      // };
      // const res = await saveData(data);
      this.$router.push({
        path: '/classification'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: url(@/assets/indexImg/indexImg_bg.png) no-repeat center;
  background-size: 100% 100%;
  border-radius: 0px;
}

.theme {
  position: absolute;
  top: 115px;
  left: 50%;
  transform: translate(-50%);
  width: 450px;
  height: 42px;
  background: url(@/assets/indexImg/indexImg_theme.png) no-repeat center;
  background-size: 100% 100%;
}
.title {
  position: absolute;
  top: 175px;
  left: 50%;
  transform: translate(-50%);
  width: 693px;
  height: 171px;
  background: url(@/assets/indexImg/indexImg_title.png) no-repeat center;
  background-size: 100% 100%;
}
.subtitle {
  position: absolute;
  top: 360px;
  left: 50%;
  transform: translate(-50%);
  width: 275px;
  height: 44px;
  background: url(@/assets/indexImg/indexImg_subtitle.png) no-repeat center;
  background-size: 100% 100%;
}
.illustration {
  position: absolute;
  top: 360px;
  // left: 50%;
  // transform: translate(-50%);
  width: 735px;
  height: 620px;
  background: url(@/assets/indexImg/indexImg_illustration.png) no-repeat center;
  background-size: 100% 100%;
}
.goClassification {
  cursor: pointer;
  width: 400px;
  height: 109px;
  position: absolute;
  z-index: 2;
  top: 1075px;
  left: 50%;
  transform: translate(-50%);
  background: url(@/assets/indexImg/indexImg_button.png) no-repeat center;
  background-size: 100% 100%;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-size: 46px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
}
.bottomMask {
  width: 330px;
  height: 60px;
  border-radius: 50%;
  position: absolute;
  z-index: 1;
  top: 1155px;
  left: 50%;
  transform: translate(-50%);
  filter: blur(40px);
  background: rgba(52, 115, 252, 0.7);
}
</style>
